import { render, staticRenderFns } from "./AutoCrudEdit.vue?vue&type=template&id=efc5077e&"
import script from "./AutoCrudEdit.vue?vue&type=script&lang=js&"
export * from "./AutoCrudEdit.vue?vue&type=script&lang=js&"
import style0 from "./AutoCrudEdit.vue?vue&type=style&index=0&id=efc5077e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports